import moment from 'moment';

export const formatToDispalyDate = (date: Date) => {
  return moment(date).format('DD:MM:YYYY HH:mm');
};
